import { inject, Pipe, PipeTransform } from '@angular/core';
import { ComponentService } from '@services/component.service';
import { WindowService } from '@services/window.service';
import { CarsRoutes } from 'types/Car';

@Pipe({
  name: 'evModelPath',
  pure: false,
})
export class EvModelPathPipe implements PipeTransform {
  private windowService = inject(WindowService);
  private componentService = inject(ComponentService);

  public transform(path: string): string {
    const isEvModelAccessible =
      this.windowService.isSuperTenant() && this.componentService.isFeatureActive('EVMODELS_PAGE_REDESIGN');

    if (path === CarsRoutes.CARS && isEvModelAccessible) {
      return CarsRoutes.EVMODELS_LIST;
    }

    return path;
  }
}
